import React from "react";
import styled from "styled-components";
import CategoryItem from "./CategoryItem";
import { mobile } from "./../../responsive";

import { categories } from "../../data";

const Container = styled.div`
  display: flex;
  padding: 20px;
  justify-content: space-between;

  ${mobile({ padding: "0px", flexDirection: "column" })}
`;

const Categories = () => {
  return (
    <Container>
      {categories.map((item) => (
        // <img src={item.img} alt="" />
        <CategoryItem key={item.id} item={item} />
      ))}
    </Container>
  );
};

export default Categories;
